import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import 'flag-icons/css/flag-icons.min.css';
import '@fontsource/noto-sans/400.css';
import '@fontsource/noto-sans/500.css';
import '@fontsource/noto-sans/600.css';
import '@fontsource/noto-sans/700.css';
import '@fontsource/aleo/400.css';
import '@fontsource/aleo/700.css';
import App from './app/App';
import ErrorBoundary from './app/layout/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

